webpackJsonp([42],{

/***/ 225:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(671);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_AuthStore__ = __webpack_require__(678);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_CategoriesStore__ = __webpack_require__(699);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_ColumnStore__ = __webpack_require__(728);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_ConfigStore__ = __webpack_require__(729);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_OrganizationStore__ = __webpack_require__(730);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_RoleStore__ = __webpack_require__(743);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_SitesStore__ = __webpack_require__(744);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modules_SiteStore__ = __webpack_require__(745);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__modules_UserStore__ = __webpack_require__(746);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__modules_WechatStore__ = __webpack_require__(750);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__modules_VideosStore__ = __webpack_require__(751);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__modules_CeramicsStore__ = __webpack_require__(752);


















__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);
var store = {
  state: __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */],
  modules: {
    AuthStore: __WEBPACK_IMPORTED_MODULE_3__modules_AuthStore__["a" /* default */],
    SiteStore: __WEBPACK_IMPORTED_MODULE_10__modules_SiteStore__["a" /* default */],
    UserStore: __WEBPACK_IMPORTED_MODULE_11__modules_UserStore__["a" /* default */],
    OrganizationStore: __WEBPACK_IMPORTED_MODULE_7__modules_OrganizationStore__["a" /* default */],
    RoleStore: __WEBPACK_IMPORTED_MODULE_8__modules_RoleStore__["a" /* default */],
    ColumnStore: __WEBPACK_IMPORTED_MODULE_5__modules_ColumnStore__["a" /* default */],
    SitesStore: __WEBPACK_IMPORTED_MODULE_9__modules_SitesStore__["a" /* default */],
    ConfigStore: __WEBPACK_IMPORTED_MODULE_6__modules_ConfigStore__["a" /* default */],
    WechatStore: __WEBPACK_IMPORTED_MODULE_12__modules_WechatStore__["a" /* default */],
    CategoriesStore: __WEBPACK_IMPORTED_MODULE_4__modules_CategoriesStore__["a" /* default */],
    VideosStore: __WEBPACK_IMPORTED_MODULE_13__modules_VideosStore__["a" /* default */],
    CeramicsStore: __WEBPACK_IMPORTED_MODULE_14__modules_CeramicsStore__["a" /* default */]
  }
};
var state = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store(store);
/* harmony default export */ __webpack_exports__["a"] = (state);

/***/ }),

/***/ 397:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'App'
});

/***/ }),

/***/ 398:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_iview__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_iview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_iview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__(670);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_web__ = __webpack_require__(753);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_admin__ = __webpack_require__(754);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_manage__ = __webpack_require__(755);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_root__ = __webpack_require__(942);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_cms__ = __webpack_require__(943);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_wechat__ = __webpack_require__(944);












__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_0_iview___default.a);

var routes = [].concat(__WEBPACK_IMPORTED_MODULE_4__modules_web__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__modules_admin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__modules_manage__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__modules_cms__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__modules_wechat__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__modules_root__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
  mode: 'history',
  routes: routes
});

router.beforeEach(function (to, from, next) {
  __WEBPACK_IMPORTED_MODULE_0_iview___default.a.LoadingBar.start();

  document.title = to.meta.name ? __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.name + ' -- ' + to.meta.name : __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.name;

  if (to.matched.some(function (r) {
    return r.meta.requireAuth;
  })) {
    if (__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.AuthStore.jwtToken) {
      next();
    } else {
      next({
        name: 'auth.login',
        query: {
          redirect: to.fullPath
        }
      });
    }
  } else {
    next();
  }
});

router.afterEach(function () {
  __WEBPACK_IMPORTED_MODULE_0_iview___default.a.LoadingBar.finish();
  window.scrollTo(0, 0);
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ 414:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return flattenTree; });
/* unused harmony export normalizerPropertyOption */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getBreadcrumb; });
/* unused harmony export isObjectEquals */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);




var flattenTree = function flattenTree(node) {
  if (node.children && node.children.length) {
    var item = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(node));
    delete item.children;
    var result = [item];
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(node.children), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var child = _step.value;

        result = result.concat(flattenTree(child));
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    return result;
  }
  return node;
};

var normalizerPropertyOption = function normalizerPropertyOption(item) {
  item.value = item.id;
  item.label = item.name;
  delete item.id;
  delete item.name;
  item.customProperties = {};
  if (item['拼音']) {
    item.customProperties['pinyin'] = item['拼音'];
    delete item['拼音'];
  }
  if (item['拼音首字母']) {
    item.customProperties['pinyin_abbr'] = item['拼音首字母'];
    delete item['拼音首字母'];
  }
  return item;
};

function getBreadcrumb(id, array, breadcrumb) {
  for (var i = 0; i < array.length; i++) {
    var item = array[i];
    breadcrumb.push(item);
    if (item.id === id) {
      return breadcrumb;
    }
    if (Array.isArray(item.children)) {
      var result = getBreadcrumb(id, item.children, breadcrumb);
      if (result !== false) {
        return result;
      }
    }
    breadcrumb.pop();
  }
  return false;
}

function isObjectEquals(x, y) {
  if (x === y) return true;


  if (!(x instanceof Object) || !(y instanceof Object)) return false;


  if (x.constructor !== y.constructor) return false;


  for (var p in x) {
    if (!x.hasOwnProperty(p)) continue;


    if (!y.hasOwnProperty(p)) return false;


    if (x[p] === y[p]) continue;


    if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(x[p]) !== 'object') return false;


    if (!isObjectEquals(x[p], y[p])) return false;
  }

  for (p in y) {
    if (y.hasOwnProperty(p) && !x.hasOwnProperty(p)) return false;
  }
  return true;
}



/***/ }),

/***/ 424:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_url_search_params_polyfill__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_url_search_params_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_url_search_params_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_polyfill__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bootstrap_vue__ = __webpack_require__(635);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__App__ = __webpack_require__(665);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__router__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__core_auth__ = __webpack_require__(945);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__core_mixins_iview__ = __webpack_require__(946);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vee_validate__ = __webpack_require__(947);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vee_validate_dist_locale_zh_CN__ = __webpack_require__(948);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vee_validate_dist_locale_zh_CN___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vee_validate_dist_locale_zh_CN__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_localforage__ = __webpack_require__(949);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_localforage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_localforage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_sweetalert2__ = __webpack_require__(950);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_iview__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_iview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_iview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__directives__ = __webpack_require__(953);



















__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_14_iview___default.a);

__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_vee_validate__["b" /* default */], {
  events: 'input|change',
  fieldsBagName: 'formFields'
});
__WEBPACK_IMPORTED_MODULE_10_vee_validate__["a" /* Validator */].localize('zh', __WEBPACK_IMPORTED_MODULE_11_vee_validate_dist_locale_zh_CN___default.a);

__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_bootstrap_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_13_vue_sweetalert2__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].mixin(__WEBPACK_IMPORTED_MODULE_8__core_mixins_iview__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_12_localforage___default.a.config({
  name: 'app'
});

__WEBPACK_IMPORTED_MODULE_3_vue__["default"].prototype.$axios = __WEBPACK_IMPORTED_MODULE_7__core_auth__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].prototype.$storage = __WEBPACK_IMPORTED_MODULE_12_localforage___default.a;

__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_15__directives__).forEach(function (k) {
  return __WEBPACK_IMPORTED_MODULE_3_vue__["default"].directive(k, __WEBPACK_IMPORTED_MODULE_15__directives__[k]);
});

window.vue = new __WEBPACK_IMPORTED_MODULE_3_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */],
  components: {
    App: __WEBPACK_IMPORTED_MODULE_5__App__["a" /* default */]
  },
  template: '<App/>'
});

/***/ }),

/***/ 665:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_node_modules_iview_loader_index_js_ref_1_1_App_vue__ = __webpack_require__(397);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f65d2b0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_node_modules_iview_loader_index_js_ref_1_1_App_vue__ = __webpack_require__(669);
function injectStyle (ssrContext) {
  __webpack_require__(666)
  __webpack_require__(668)
}
var normalizeComponent = __webpack_require__(416)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_node_modules_iview_loader_index_js_ref_1_1_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f65d2b0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_node_modules_iview_loader_index_js_ref_1_1_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 666:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 668:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 669:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-view')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 671:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cms__ = __webpack_require__(672);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__footer__ = __webpack_require__(673);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__queues__ = __webpack_require__(674);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__sms__ = __webpack_require__(675);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__wechat__ = __webpack_require__(676);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__panorama__ = __webpack_require__(677);







var state = {
  name: '景德镇御窑厂 后台管理程序',
  default: {
    apiBase: "https://api.yyc.52wenbo.com/api/v1/",
    sessionTimeout: 90,

    jwtTimeout: 60,
    notice: {
      warning: {
        duration: 8
      },
      error: {
        duration: 8
      }
    },
    cms: __WEBPACK_IMPORTED_MODULE_0__cms__["a" /* default */],
    queues: __WEBPACK_IMPORTED_MODULE_2__queues__["a" /* default */],
    sms: __WEBPACK_IMPORTED_MODULE_3__sms__["a" /* default */],
    wechat: __WEBPACK_IMPORTED_MODULE_4__wechat__["a" /* default */],
    panorama: __WEBPACK_IMPORTED_MODULE_5__panorama__["a" /* default */]
  },
  footer: __WEBPACK_IMPORTED_MODULE_1__footer__["a" /* default */]
};
/* harmony default export */ __webpack_exports__["a"] = (state);

/***/ }),

/***/ 672:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  article: {
    image: {
      maxSize: 1024 * 1024,
      uploadSize: 10 * 1024 * 1024
    },
    attachment: {
      file: {
        maxSize: 10,
        format: [],
        name: '附件'
      },
      video: {
        maxSize: 50,
        format: ['mp4', 'avi'],
        name: '视频'
      }
    }
  },
  category_types: [{
    value: 'page',
    name: '页面型'
  }, {
    value: 'catalogue',
    name: '目录型'
  }, {
    value: 'list',
    name: '内容列表'
  }, {
    value: 'link',
    name: '链接型'
  }, {
    value: 'video',
    name: '视频型'
  }],
  templates: {
    list: [{
      value: 'with-thumbnail',
      name: '带略缩图型列表'
    }, {
      value: 'text-list',
      name: '文本型列表'
    }],
    article: [{
      value: 'mordern',
      name: '现代型模版'
    }, {
      value: 'classic',
      name: '古典型模版'
    }],
    video: [{
      value: 'basic',
      name: '基本型模版'
    }],
    page: [{
      value: 'block',
      name: '区块显示'
    }, {
      value: 'basic',
      name: '基本型模版'
    }],
    portfolio: [{
      value: 'basic',
      name: '基本型模版'
    }],
    picture: [{
      value: 'basic',
      name: '基本型模版'
    }]
  }
});

/***/ }),

/***/ 673:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  title: '景德镇御窑厂 后台管理程序',
  version: '0.15.2',
  copyright: '&copy; 2019 景德镇御窑厂',
  link: 'http://docs.zdbx.net',
  subtitle: '景德镇御窑厂'
});

/***/ }),

/***/ 674:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
  value: 'zdbx-critical',
  name: '系统关键任务'
}, {
  value: 'zdbx-filesystem',
  name: '文件处理任务'
}, {
  value: 'wechat-notify',
  name: '微信模版消息'
}, {
  value: 'zdbx-default',
  name: '系统普通任务'
}, {
  value: 'default',
  name: '系统默认任务'
}]);

/***/ }),

/***/ 675:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  types: [{
    text: '短信通知',
    value: 'notification'
  }, {
    text: '验证码',
    value: 'code'
  }, {
    text: '推广广告',
    value: 'marketing'
  }],
  usages: [{
    text: '密码找回',
    value: 'password_reset'
  }, {
    text: '绑定手机号码',
    value: 'mobile_binding'
  }, {
    text: '用户注册',
    value: 'user_register'
  }, {
    text: '消息通知',
    value: 'notice_notification'
  }],
  signatures: [{
    text: '景德镇窑厂',
    value: '景德镇语窑厂'
  }]
});

/***/ }),

/***/ 676:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  types: {
    subscribe: '订阅号',
    service: '服务号',
    mini: '小程序',
    enterprise: '企业微信'
  },
  usages: {
    point_change: '积分变更提醒',
    expire_client: '会员过期提醒',
    level_change: '等级变更提醒'
  }
});

/***/ }),

/***/ 677:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  types: [{
    value: 'panorama',
    name: '全景'
  }, {
    value: 'poi',
    name: '兴趣点POI'
  }]
});

/***/ }),

/***/ 678:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jwt_decode__ = __webpack_require__(679);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jwt_decode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jwt_decode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);



/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    jwtToken: sessionStorage.getItem('jwtToken'),
    updatedAt: Number(sessionStorage.getItem('jwtTokenUpdatedAt')),
    requestedAt: Number(sessionStorage.getItem('requestedAt'))
  },
  mutations: {
    login: function login(state, jwtToken) {
      state.jwtToken = jwtToken;
      state.updatedAt = new Date().getTime();
      state.requestedAt = new Date().getTime();
      sessionStorage.setItem('jwtToken', jwtToken);
      sessionStorage.setItem('jwtTokenUpdatedAt', state.updatedAt);
      sessionStorage.setItem('requestedAt', state.requestedAt);
    },
    logout: function logout(state) {
      state.jwtToken = null;
      state.updatedAt = null;
    },
    requested: function requested(state) {
      state.requestedAt = new Date().getTime();

      sessionStorage.setItem('requestedAt', state.requestedAt);
    },
    refresh: function refresh(state) {
      var now = +new Date();

      state.updatedAt = now;
      sessionStorage.setItem('jwtTokenUpdatedAt', now);
    }
  },
  actions: {
    login: function login(_ref, jwtToken) {
      var commit = _ref.commit;

      commit('login', jwtToken);
      commit('requested');
    },
    logout: function logout(_ref2) {
      var commit = _ref2.commit;

      __WEBPACK_IMPORTED_MODULE_1_axios___default()('/web/auth/logout/').then(function () {
        console.log('用户退出登录');
      }).catch(function (error) {
        console.error(error);
      }).then(function () {
        commit('SiteStore/reset', {}, { root: true });
        commit('UserStore/reset', {}, { root: true });
        commit('logout');
        sessionStorage.clear();
      });
    },
    requested: function requested(_ref3) {
      var commit = _ref3.commit;

      commit('requested');
    },
    refreshToken: function refreshToken(_ref4) {
      var commit = _ref4.commit;

      __WEBPACK_IMPORTED_MODULE_1_axios___default()('/web/auth/refresh/').then(function (response) {
        commit('requested');
        commit('login', response.data.token);
      }).catch(function (error) {
        console.error(error);
      }).then(function () {
        commit('refresh');
      });
    }
  },
  getters: {
    token: function token(state) {
      return state.jwtToken;
    },
    requestedAt: function requestedAt(state) {
      return state.requestedAt;
    },
    updatedAt: function updatedAt(state) {
      return state.updatedAt;
    },
    expirationDate: function expirationDate(state) {
      if (!state.jwtToken) {
        return null;
      }
      var token = __WEBPACK_IMPORTED_MODULE_0_jwt_decode___default()(state.jwtToken);
      if (!token.exp) {
        return null;
      }
      var date = new Date(0);
      date.setUTCSeconds(token.exp);
      return date;
    },
    tokenValid: function tokenValid(state, getters) {
      var expirationDate = getters.expirationDate;
      if (expirationDate === null) {
        return false;
      }
      return expirationDate > new Date();
    },
    valid: function valid(state) {
      if (!state.jwtToken || state.jwtToken === '' || !state.updatedAt) {
        return false;
      }
      var start = state.updatedAt;
      var now = new Date().getTime();
      var diff = now - start;

      if (diff > 60 * 60 * 1000) {
        return false;
      }
      return true;
    }
  }
});

/***/ }),

/***/ 699:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);







/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    categories: sessionStorage.getItem('categories') ? JSON.parse(sessionStorage.getItem('categories')) : false
  },
  mutations: {
    categories: function categories(state, _categories) {
      state.categories = _categories;
    },
    id: function id(state, _id) {
      state.id = _id;
    },
    fetch: function fetch(state, categories) {
      state.categories = categories;
      sessionStorage.setItem('categories', __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(categories));
    },
    reset: function reset(state) {
      state.categories = false;
      sessionStorage.removeItem('categories');
    }
  },
  actions: {
    categories: function categories(_ref, _categories2) {
      var commit = _ref.commit;

      commit('categories', _categories2);
    },
    fetch: function fetch(_ref2) {
      var _this = this;

      var commit = _ref2.commit,
          state = _ref2.state;
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        var res;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(state.categories === false)) {
                  _context.next = 9;
                  break;
                }

                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_5_axios___default()('/common/cms/category/');

              case 3:
                res = _context.sent;
                _context.t0 = commit;
                _context.next = 7;
                return res.data;

              case 7:
                _context.t1 = _context.sent;
                (0, _context.t0)('fetch', _context.t1);

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    reset: function reset(_ref3) {
      var commit = _ref3.commit,
          state = _ref3.state;

      commit('reset', state);
    }
  },
  getters: {
    categories: function categories(state) {
      return state.categories;
    },
    breadcrumb: function breadcrumb(state) {
      return function (category_id) {
        if (state.categories === false) {
          return false;
        }
        var getBreadcrumbs = function getBreadcrumbs(items, id) {
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(items), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var item = _step.value;

              if (item.id === id) {
                return [item];
              }
              if (!item.children || !Array.isArray(item.children) || item.children.length === 0) {
                continue;
              }

              var result = getBreadcrumbs(item.children, id);

              if (Array.isArray(result)) {
                return [item].concat(result);
              }
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }

          return false;
        };
        var categories = state.categories;
        return getBreadcrumbs(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(categories), category_id);
      };
    }
  }
});

/***/ }),

/***/ 728:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    columnTitle: ''
  },
  mutations: {
    columnTitle: function columnTitle(state, _columnTitle) {
      state.columnTitle = _columnTitle;
    }
  },
  getters: {
    columnTitle: function columnTitle(state) {
      return state.columnTitle;
    }
  }
});

/***/ }),

/***/ 729:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);



/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    config: sessionStorage.getItem('config') ? JSON.parse(sessionStorage.getItem('config')) : false
  },
  mutations: {
    getConfig: function getConfig(state, config) {
      state.config = config;
      sessionStorage.setItem('config', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(config));
    }
  },
  actions: {
    getConfig: function getConfig(_ref) {
      var commit = _ref.commit;

      if (sessionStorage.getItem('config')) {
        return false;
      }
      __WEBPACK_IMPORTED_MODULE_1_axios___default()('/common/schema/config').then(function (response) {
        commit('getConfig', response.data.properties.ceramic.default);
      });
    }
  },
  getters: {
    config: function config(state) {
      return state.config || [];
    }
  }
});

/***/ }),

/***/ 730:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__core_util__ = __webpack_require__(414);








/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    organizations: sessionStorage.getItem('organizations') ? JSON.parse(sessionStorage.getItem('organizations')) : false
  },
  mutations: {
    update: function update(state, organizations) {
      state.organizations = organizations;
      sessionStorage.setItem('organizations', __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(organizations));
    },
    reset: function reset(state) {
      state.organizations = false;
      sessionStorage.removeItem('organizations');
    }
  },
  actions: {
    fetch: function fetch(_ref, force) {
      var _this = this;

      var commit = _ref.commit,
          state = _ref.state;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var res;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(state.organizations !== false && force !== true)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt('return');

              case 2:
                state.organizations = false;
                _context.next = 5;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default()('/common/organization/');

              case 5:
                res = _context.sent;
                _context.t0 = commit;
                _context.next = 9;
                return res.data;

              case 9:
                _context.t1 = _context.sent;
                (0, _context.t0)('update', _context.t1);

              case 11:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    reset: function reset(_ref2) {
      var commit = _ref2.commit;

      commit('reset');
    }
  },
  getters: {
    organization: function organization(state) {
      return function (id, breadcrumb) {
        if (state.organizations === false) {
          return null;
        }
        var result = [];
        Object(__WEBPACK_IMPORTED_MODULE_5__core_util__["b" /* getBreadcrumb */])(id, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(state.organizations), result);
        if (result === false) {
          return null;
        }
        if (breadcrumb) {
          return result;
        }
        if (!result.length) {
          return null;
        }
        var fullname = result.map(function (item) {
          return item.name;
        }).join(' / ');
        result = result.pop();
        result.fullname = fullname;
        return result;
      };
    },
    organizations: function organizations(state) {
      return state.organizations;
    }
  }
});

/***/ }),

/***/ 743:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__core_util__ = __webpack_require__(414);








/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    roles: sessionStorage.getItem('rolestore_roles') ? JSON.parse(sessionStorage.getItem('rolestore_roles')) : false
  },
  mutations: {
    roles: function roles(state, _roles) {
      state.roles = _roles;
    },
    id: function id(state, _id) {
      state.id = _id;
    },
    fetch: function fetch(state, roles) {
      state.roles = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values___default()(roles);
      sessionStorage.setItem('rolestore_roles', __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(state.roles));
    }
  },
  actions: {
    roles: function roles(_ref, _roles2) {
      var commit = _ref.commit;

      commit('roles', _roles2);
    },
    fetch: function fetch(_ref2) {
      var _this = this;

      var commit = _ref2.commit,
          state = _ref2.state;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var res;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (state.roles) {
                  _context.next = 9;
                  break;
                }

                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_5_axios___default()('/common/role');

              case 3:
                res = _context.sent;
                _context.t0 = commit;
                _context.next = 7;
                return res.data;

              case 7:
                _context.t1 = _context.sent;
                (0, _context.t0)('fetch', _context.t1);

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  },
  getters: {
    roles: function roles(state) {
      return function (ids) {
        if (!ids) {
          return state.roles;
        }

        function findRoles(ids, roles, result) {
          for (var i = 0; i < roles.length; i++) {
            var role = roles[i];
            if (ids.includes(role.id)) {
              var item = JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(role));
              delete item.children;
              result.push(item);
            }
            if (role.children && role.children.length) {
              findRoles(ids, role.children, result);
            }
          }
          return result;
        }

        var result = [];
        findRoles(ids, state.roles, result);
        return result;
      };
    },
    children: function children(state) {
      return function (roleIds, flatten) {
        if (!state.roles) {
          return false;
        }

        function findRole(id, roles) {
          for (var i = 0; i < roles.length; i++) {
            var item = roles[i];
            if (item.id === id) {
              return item;
            }
            if (Array.isArray(item.children)) {
              var _result = findRole(id, item.children);
              if (_result !== false) {
                return _result;
              }
            }
          }
          return false;
        }
        roleIds = Array.isArray(roleIds) ? roleIds : [roleIds];

        var result = [];
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(roleIds), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var id = _step.value;

            var role = findRole(id, __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values___default()(state.roles));
            if (flatten) {
              result = result.concat(Object(__WEBPACK_IMPORTED_MODULE_6__core_util__["a" /* flattenTree */])(role));
            } else {
              result = result.concat(role);
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        return result;
      };
    }
  }
});

/***/ }),

/***/ 744:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);



/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    sites: sessionStorage.getItem('sitesstore_sites') ? JSON.parse(sessionStorage.getItem('sitesstore_sites')) : false
  },
  mutations: {
    fetch: function fetch(state, sites) {
      state.sites = sites;
      sessionStorage.setItem('sitesstore_sites', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(sites));
    }
  },
  actions: {
    fetch: function fetch(_ref) {
      var commit = _ref.commit,
          state = _ref.state;

      if (state.sites) {
        return false;
      }
      __WEBPACK_IMPORTED_MODULE_1_axios___default()('/common/site/').then(function (response) {
        commit('fetch', response.data);
      }).catch(function (error) {
        console.error(error);
      });
    }
  },
  getters: {
    sites: function sites(state) {
      return state.sites || [];
    }
  }
});

/***/ }),

/***/ 745:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    modules: JSON.parse(localStorage.getItem('modules')),
    permissions: JSON.parse(localStorage.getItem('permissions')),
    roles: JSON.parse(localStorage.getItem('roles')),
    site: localStorage.getItem('site')
  },
  mutations: {
    modules: function modules(state, _modules) {
      state.modules = _modules;
      localStorage.setItem('modules', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_modules));
    },
    permissions: function permissions(state, _permissions) {
      state.permissions = _permissions;
      localStorage.setItem('permissions', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_permissions));
    },
    roles: function roles(state, _roles) {
      state.roles = _roles;
      localStorage.setItem('roles', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_roles));
    },
    site: function site(state, _site) {
      state.site = _site;
      localStorage.setItem('site', _site);
    },
    reset: function reset(state) {
      state.modules = null;
      state.permissions = null;
      state.roles = null;
      state.site = null;

      localStorage.removeItem('modules');
      localStorage.removeItem('permissions');
      localStorage.removeItem('roles');
      localStorage.removeItem('site');
    }
  },
  getters: {
    permissions: function permissions(state) {
      return state.permissions;
    },
    roles: function roles(state) {
      return state.roles;
    },
    menuitems: function menuitems(state) {
      var menuitems = [];
      if (state.modules) {
        for (var i = 0; i < state.modules.length; i++) {
          var module = state.modules[i];
          if (Array.isArray(module.menuitems) && module.menuitems.length > 0) {
            menuitems = menuitems.concat([{
              id: module.id,
              title: true,
              name: module.name,
              classname: '',
              wrapper: {
                element: 'span',
                attributes: module.attributes
              }
            }]);
            menuitems = menuitems.concat(module.menuitems);
          }
        }
        return menuitems;
      }
      return null;
    },
    modules: function modules(state) {
      return state.modules;
    },
    site: function site(state) {
      return state.site;
    }
  }
});

/***/ }),

/***/ 746:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);







/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    user: localStorage.getItem('loginedUser') ? JSON.parse(localStorage.getItem('loginedUser')) : null,
    sites: localStorage.getItem('grantedSites') ? JSON.parse(localStorage.getItem('grantedSites')) : null
  },
  mutations: {
    fetch: function fetch(state, payload) {
      state.user = payload.user;
      state.sites = payload.sites;
      localStorage.setItem('loginedUser', __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(payload.user));
      localStorage.setItem('grantedSites', __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(payload.sites));
    },
    name: function name(state, _name) {
      if (state.user && state.user.name) {
        state.user.name = _name;
        localStorage.setItem('loginedUser', __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(state.user));
      }
    },
    mobile: function mobile(state, _mobile) {
      if (state.user && state.user.mobile) {
        state.user.mobile = _mobile;
        localStorage.setItem('loginedUser', __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(state.user));
      }
    },
    email: function email(state, _email) {
      if (state.user && state.user.email) {
        state.user.email = _email;
        state.user.validated_at = null;
        localStorage.setItem('loginedUser', __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(state.user));
      }
    },
    validated: function validated(state) {
      if (state.user && state.user.email) {
        state.user.validated_at = new Date();
        localStorage.setItem('loginedUser', __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(state.user));
      }
    },
    avatar: function avatar(state, url) {
      if (state.user) {
        state.user.avatar_url = url;
        localStorage.setItem('loginedUser', __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(state.user));
      }
    },
    reset: function reset(state) {
      state.user = null;
      state.sites = null;
      localStorage.removeItem('loginedUser');
      localStorage.removeItem('grantedSites');
    }
  },
  actions: {
    fetch: function fetch(_ref) {
      var _this = this;

      var commit = _ref.commit;
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _ref2, _ref3, userRes, sitesRes;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([__WEBPACK_IMPORTED_MODULE_5_axios___default.a.get('/web/user/info/'), __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get('/web/user/site/')]);

              case 2:
                _ref2 = _context.sent;
                _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref2, 2);
                userRes = _ref3[0];
                sitesRes = _ref3[1];

                commit('fetch', { user: userRes.data, sites: sitesRes.data });

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    name: function name(_ref4, _name2) {
      var commit = _ref4.commit;

      commit('name', _name2);
    },
    mobile: function mobile(_ref5, _mobile2) {
      var commit = _ref5.commit;

      commit('mobile', _mobile2);
    },
    email: function email(_ref6, _email2) {
      var commit = _ref6.commit;

      commit('email', _email2);
    },
    validated: function validated(_ref7) {
      var commit = _ref7.commit;

      commit('validated');
    },
    avatar: function avatar(_ref8, url) {
      var commit = _ref8.commit;

      commit('avatar', url);
    }
  },
  getters: {
    info: function info(state) {
      if (state.user) {
        return state.user;
      }
      if (localStorage.getItem('loginedUser')) {
        return JSON.parse(localStorage.getItem('loginedUser'));
      }
      return null;
    },
    id: function id(state) {
      if (state.user && state.user.id) {
        return state.user.id;
      }
      return null;
    },
    avatar: function avatar(state, getters) {
      return getters.info ? getters.info.avatar_url : null;
    },
    sites: function sites(state) {
      return state.sites || [];
    }
  }
});

/***/ }),

/***/ 750:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);





/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    wechats: sessionStorage.getItem('wechatstore_wechats') ? JSON.parse(sessionStorage.getItem('wechatstore_wechats')) : false
  },
  mutations: {
    fetch: function fetch(state, wechats) {
      state.wechats = wechats;
      sessionStorage.setItem('wechatstore_wechats', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(wechats));
    }
  },
  actions: {
    roles: function roles(_ref, _roles) {
      var commit = _ref.commit;

      commit('roles', _roles);
    },
    fetch: function fetch(_ref2, site) {
      var _this = this;

      var commit = _ref2.commit;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default()('/web/user/wechat/' + site + '/');

              case 2:
                res = _context.sent;
                _context.t0 = commit;
                _context.next = 6;
                return res.data;

              case 6:
                _context.t1 = _context.sent;
                (0, _context.t0)('fetch', _context.t1);

              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  },
  getters: {
    wechats: function wechats(state) {
      return state.wechats || [];
    }
  }
});

/***/ }),

/***/ 751:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);





/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    videos: sessionStorage.getItem('videos') ? JSON.parse(sessionStorage.getItem('videos')) : false
  },
  mutations: {
    fetch: function fetch(state, videos) {
      state.videos = videos;
      sessionStorage.setItem('videos', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(videos));
    },
    reset: function reset(state) {
      state.videos = false;
      sessionStorage.removeItem('videos');
    }
  },
  actions: {
    fetch: function fetch(_ref, site) {
      var _this = this;

      var commit = _ref.commit,
          state = _ref.state;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (state.videos) {
                  _context.next = 5;
                  break;
                }

                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default()({
                  url: '/common/cms/video/?audit=1&visible=1',
                  method: 'GET',
                  data: {
                    pageSize: 1000,
                    visible: 1,
                    audit: 1
                  },
                  headers: {
                    'X-SITE-ID': site
                  }
                });

              case 3:
                res = _context.sent;

                commit('fetch', res.data.data);

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    reset: function reset(_ref2) {
      var commit = _ref2.commit;

      commit('reset');
    }
  },
  getters: {
    videos: function videos(state) {
      return state.videos || [];
    }
  }
});

/***/ }),

/***/ 752:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);





/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    ceramics: sessionStorage.getItem('ceramics') ? JSON.parse(sessionStorage.getItem('ceramics')) : false
  },
  mutations: {
    fetch: function fetch(state, ceramics) {
      state.ceramics = ceramics;
      sessionStorage.setItem('ceramics', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(ceramics));
    },
    reset: function reset(state) {
      state.ceramics = false;
      sessionStorage.removeItem('ceramics');
    }
  },
  actions: {
    fetch: function fetch(_ref) {
      var _this = this;

      var commit = _ref.commit,
          state = _ref.state;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (state.ceramics) {
                  _context.next = 5;
                  break;
                }

                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default()({
                  url: '/business/ceramic/?audit=1&visible=1',
                  method: 'GET'
                });

              case 3:
                res = _context.sent;

                commit('fetch', res.data);

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    reset: function reset(_ref2) {
      var commit = _ref2.commit;

      commit('reset');
    }
  },
  getters: {
    ceramics: function ceramics(state) {
      return state.ceramics || [];
    }
  }
});

/***/ }),

/***/ 753:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/',
  redirect: '/web/auth/login'
}, {
  path: '/web/auth/login',
  name: 'auth.login',
  meta: {
    name: '用户登录'
  },
  component: function component() {
    return __webpack_require__.e/* import() */(31).then(__webpack_require__.bind(null, 961));
  }
}, {
  path: '/web/register/mobile',
  name: 'register.mobile',
  meta: {
    name: '手机注册'
  },
  component: function component() {
    return __webpack_require__.e/* import() */(28).then(__webpack_require__.bind(null, 962));
  }
}, {
  path: '/web/register/email',
  name: 'register.email',
  meta: {
    name: '邮箱注册'
  },
  component: function component() {
    return __webpack_require__.e/* import() */(30).then(__webpack_require__.bind(null, 963));
  }
}, {
  path: '/web/register/email/code/:token/',
  name: 'register.email.code',
  meta: {
    name: '邮箱注册（邮箱验证）'
  },
  component: function component() {
    return __webpack_require__.e/* import() */(39).then(__webpack_require__.bind(null, 964));
  }
}, {
  path: '/web/password/email/',
  name: 'password.email',
  meta: {
    name: '邮箱密码重置'
  },
  component: function component() {
    return __webpack_require__.e/* import() */(37).then(__webpack_require__.bind(null, 965));
  }
}, {
  path: '/web/password/email/code/:token/',
  name: 'password.email.code',
  meta: {
    name: '邮箱密码重置（验证）'
  },
  component: function component() {
    return __webpack_require__.e/* import() */(40).then(__webpack_require__.bind(null, 966));
  }
}, {
  path: '/web/password/mobile',
  name: 'password.mobile',
  meta: {
    name: '手机密码重置'
  },
  component: function component() {
    return __webpack_require__.e/* import() */(36).then(__webpack_require__.bind(null, 967));
  }
}, {
  path: '/web/user/email/code/:token/',
  name: 'user.email.code',
  meta: {
    name: '验证邮箱绑定'
  },
  component: function component() {
    return __webpack_require__.e/* import() */(38).then(__webpack_require__.bind(null, 968));
  }
}, {
  path: '/',
  name: 'index',
  component: function component() {
    return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, 969));
  }
}]);

/***/ }),

/***/ 754:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/admin/:site/',
  name: 'admin.home',
  component: function component() {
    return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 106));
  },
  children: [{
    path: 'organization',
    name: 'admin.organization',
    component: function component() {
      return __webpack_require__.e/* import() */(27).then(__webpack_require__.bind(null, 970));
    }
  }, {
    path: 'rbac/permission',
    name: 'admin.rbac.permission',
    component: function component() {
      return __webpack_require__.e/* import() */(35).then(__webpack_require__.bind(null, 971));
    }
  }, {
    path: 'rbac/role',
    name: 'admin.rbac.role',
    component: function component() {
      return __webpack_require__.e/* import() */(34).then(__webpack_require__.bind(null, 972));
    }
  }, {
    path: 'rbac/user',
    name: 'admin.rbac.user',
    component: function component() {
      return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, 973));
    }
  }, {
    path: 'system/site',
    name: 'admin.system.site',
    component: function component() {
      return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, 974));
    }
  }, {
    path: 'system/sms/template',
    name: 'admin.system.sms.template',
    component: function component() {
      return __webpack_require__.e/* import() */(22).then(__webpack_require__.bind(null, 975));
    }
  }, {
    path: 'system/module',
    name: 'admin.system.module',
    component: function component() {
      return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, 976));
    }
  }, {
    path: 'system/module/:module/menuitem/',
    name: 'admin.system.menuitem',
    component: function component() {
      return __webpack_require__.e/* import() */(25).then(__webpack_require__.bind(null, 977));
    }
  }, {
    path: 'safety/backup',
    name: 'admin.safety.backup',
    component: function component() {
      return __webpack_require__.e/* import() */(29).then(__webpack_require__.bind(null, 978));
    }
  }, {
    path: 'safety/log',
    name: 'admin.safety.log',
    component: function component() {
      return __webpack_require__.e/* import() */(26).then(__webpack_require__.bind(null, 979));
    }
  }, {
    path: 'safety/audit/system',
    name: 'admin.safety.audit.system',
    component: function component() {
      return __webpack_require__.e/* import() */(1/* duplicate */).then(__webpack_require__.bind(null, 423));
    }
  }, {
    path: 'safety/audit/business',
    name: 'admin.safety.audit.business',
    component: function component() {
      return __webpack_require__.e/* import() */(1/* duplicate */).then(__webpack_require__.bind(null, 423));
    }
  }]
}]);

/***/ }),

/***/ 755:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/manage/:site/',
  name: 'manage.home',
  component: function component() {
    return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 106));
  },
  children: [{
    path: 'user/',
    name: 'manage.user',
    meta: {
      name: '成员管理'
    },
    component: function component() {
      return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, 980));
    }
  }, {
    path: 'page/base/',
    name: 'manage.page.base',
    meta: {
      name: '基本信息'
    },
    component: function component() {
      return __webpack_require__.e/* import() */(19).then(__webpack_require__.bind(null, 981));
    }
  }, {
    path: 'page/official/',
    name: 'manage.page.official',
    meta: {
      name: '官网首页'
    },
    component: function component() {
      return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 982));
    }
  }, {
    path: 'page/carousel/',
    name: 'manage.page.carousel',
    meta: {
      name: '轮播图'
    },
    component: function component() {
      return __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, 983));
    }
  }, {
    path: 'page/mini/',
    name: 'manage.page.mini',
    meta: {
      name: '小程序页面'
    },
    component: function component() {
      return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 984));
    }
  }, {
    path: 'ceramic/',
    name: 'manage.ceramic',
    meta: {
      name: '瓷器管理'
    },
    component: function component() {
      return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 985));
    }
  }, {
    path: 'panorama/',
    name: 'manage.panorama',
    meta: {
      name: '全景管理'
    },
    component: function component() {
      return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 986));
    }
  }, {
    path: 'subscriber/',
    name: 'manage.subscriber',
    meta: {
      name: '粉丝管理'
    },
    component: function component() {
      return __webpack_require__.e/* import() */(33).then(__webpack_require__.bind(null, 987));
    }
  }, {
    path: 'client/',
    name: 'manage.client',
    meta: {
      name: '用户管理'
    },
    component: function component() {
      return __webpack_require__.e/* import() */(23).then(__webpack_require__.bind(null, 988));
    }
  }]
}]);

/***/ }),

/***/ 942:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/root/:site/',
  name: 'root.home',
  component: function component() {
    return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 106));
  },
  children: [{
    path: 'exception/job',
    name: 'root.exception.job',
    component: function component() {
      return __webpack_require__.e/* import() */(24).then(__webpack_require__.bind(null, 989));
    }
  }, {
    path: 'schema/',
    name: 'root.schema',
    component: function component() {
      return __webpack_require__.e/* import() */(20).then(__webpack_require__.bind(null, 990));
    }
  }]
}]);

/***/ }),

/***/ 943:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/cms/:site/',
  name: 'cms.home',
  component: function component() {
    return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 106));
  },
  children: [{
    path: 'category',
    name: 'cms.category',
    component: function component() {
      return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 991));
    }
  }, {
    path: 'article',
    name: 'cms.article',
    component: function component() {
      return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 992));
    }
  }, {
    path: 'article/edit/:article?',
    name: 'cms.article.edit',
    meta: {
      name: '编辑文章'
    },
    component: function component() {
      return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 993));
    }
  }, {
    path: 'video',
    name: 'cms.video',
    component: function component() {
      return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 994));
    }
  }, {
    path: 'page',
    name: 'cms.page',
    component: function component() {
      return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 995));
    }
  }, {
    path: 'media/:directory?',
    name: 'cms.media',
    meta: {
      name: '素材管理'
    },
    component: function component() {
      return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 996));
    }
  }]
}]);

/***/ }),

/***/ 944:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/wechat/:site/',
  name: 'wechat.home',
  component: function component() {
    return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 106));
  },
  children: [{
    path: 'service',
    name: 'wechat.service',
    component: function component() {
      return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, 997));
    }
  }, {
    path: 'fans',
    name: 'wechat.fans',
    component: function component() {
      return __webpack_require__.e/* import() */(32).then(__webpack_require__.bind(null, 998));
    }
  }, {
    path: 'templet',
    name: 'wechat.templet',
    component: function component() {
      return __webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, 999));
    }
  }]
}]);

/***/ }),

/***/ 945:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__router__ = __webpack_require__(398);








__WEBPACK_IMPORTED_MODULE_4_axios___default.a.defaults.timeout = 60 * 1000;
__WEBPACK_IMPORTED_MODULE_4_axios___default.a.defaults.baseURL = __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].state.default.apiBase;
__WEBPACK_IMPORTED_MODULE_4_axios___default.a.defaults.withCredentials = true;

__WEBPACK_IMPORTED_MODULE_4_axios___default.a.interceptors.request.use(function (config) {
  var token = __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters['AuthStore/token'];
  if (token) {
    config.headers.Authorization = '' + token;
  }
  var site = __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters['SiteStore/site'];
  if (site && !(config.headers && config.headers['X-SITE-ID'])) {
    config.headers['X-SITE-ID'] = site;
  }
  return config;
}, function (err) {
  return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.reject(err);
});

function getErrorMessage(error) {
  var message = error.response.data;
  if (error.response.data && typeof error.response.data.message === 'string' && error.response.data.message !== '') {
    message = error.response.data.message;
  }

  if (typeof message !== 'string') {
    message = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(message);
  }
  return message;
}

__WEBPACK_IMPORTED_MODULE_4_axios___default.a.interceptors.response.use(function (response) {
  __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].dispatch('AuthStore/requested');
  return response;
}, function (error) {
  if (error.response) {
    var body = [];
    var message = '';
    var vue = window.vue;
    var route = vue.$route;
    switch (error.response.status) {
      case 400:
        break;
      case 401:
        {
          var r = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()({
            name: route.name,
            params: route.params
          });
          console.warn('太久不操作退出登录了', r);
          window.localStorage.lastRoute = r;
          vue.$Notice.close('sessionTime');
          var lastLoginTime = sessionStorage.getItem('lastLoginedAt');
          if (lastLoginTime) {
            vue.$Notice.error({
              title: '登录超时',
              desc: '您太久没有操作了，需要重新登录后再继续操作。',
              duration: vue.$store.state.default.notice.error.duration || 8,
              name: 'sessionTime'
            });
          } else {
            vue.$Notice.warning({
              title: '未登录',
              desc: '您尚未登录，请您先登录。',
              duration: vue.$store.state.default.notice.warning.duration || 8,
              name: 'sessionTime'
            });
          }
          setTimeout(function () {
            __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].commit('AuthStore/logout');
            __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */].replace({
              name: 'auth.login'
            });
          }, 3000);
          return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.reject(error.response);
        }
      case 403:
        vue.$Notice.error({
          title: '权限错误',
          desc: '您没有权限访问该模块，请联系系统管理员。',
          duration: vue.$store.state.default.notice.error.duration || 8
        });
        break;
      case 404:
        break;
      case 422:
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(error.response.data)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var key = _step.value;

            var values = error.response.data[key];
            body.push({
              'field': key,
              'msg': values.join(',')
            });
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        error.response.data = body;
        break;
      case 423:
        if (typeof error.response.data === 'string') {
          vue.$Notice.error({
            title: '您操作的太快',
            desc: error.response.data,
            duration: vue.$store.state.default.notice.error.duration || 8
          });
          return;
        }
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(error.response.data)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var _key = _step2.value;

            var _values = error.response.data[_key];
            body.push({
              'field': _key,
              'msg': _values.join(',')
            });
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }

        error.response.data = body;
        break;
      case 500:
        message = getErrorMessage(error);
        vue.$Notice.error({
          title: '服务器内部错误',
          desc: message,
          duration: vue.$store.state.default.notice.error.duration || 8
        });
        break;
      default:
        message = getErrorMessage(error);
        vue.$Notice.error({
          title: '出错了',
          desc: '\u9519\u8BEF\u4EE3\u7801\uFF1A' + error.response.status + '\uFF0C\u8BE6\u60C5\uFF1A' + message,
          duration: vue.$store.state.default.notice.error.duration || 8
        });
        break;
    }
  }

  return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.reject(error.response);
});

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_4_axios___default.a);

/***/ }),

/***/ 946:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    onIviewDatePickerChanged: function onIviewDatePickerChanged(date, variable) {
      var object = this;
      var stack = variable.split('.');

      while (stack.length > 1) {
        object = object[stack.shift()];
      }

      if (Array.isArray(date)) {
        date = date.map(function (item) {
          return item.replace(/(年|月)+/g, '-').replace('日', '');
        });
      } else {
        date = date.replace(/(年|月)+/g, '-').replace('日', '');
      }
      object[stack.shift()] = date;
    },
    updatePaginationData: function updatePaginationData(response, name) {
      var _this = this;

      this.$set(this[name], 'data', response.data.data);
      this.$set(this[name], 'total', response.data ? response.data.total ? response.data.total : 1 : 1);
      this.$nextTick(function () {
        _this.$set(_this[name], 'current_page', response.data ? response.data.current_page ? response.data.current_page : 1 : 1);
      });
    }
  }
});

/***/ }),

/***/ 952:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 953:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_scroll__ = __webpack_require__(954);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_focus__ = __webpack_require__(956);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_highlight__ = __webpack_require__(957);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scroll", function() { return __WEBPACK_IMPORTED_MODULE_0__modules_scroll__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "focus", function() { return __WEBPACK_IMPORTED_MODULE_1__modules_focus__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "highlight", function() { return __WEBPACK_IMPORTED_MODULE_2__modules_highlight__["a"]; });





/***/ }),

/***/ 954:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_perfect_scrollbar__ = __webpack_require__(955);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'scroll',
  inserted: function inserted(el, binding, vnode) {
    if (binding.value) {
      var callback = typeof binding.value === 'function' ? binding.value : binding.value.callback;

      el.addEventListener('scroll', callback, { passive: true });
    }

    el.style.position = 'relative';
    var options = {};

    if (binding.modifiers) {
      if (binding.modifiers.y) {
        options['suppressScrollX'] = true;
      }
      if (binding.modifiers.x) {
        options['suppressScrollY'] = true;
      }
    }
    el.ps = new __WEBPACK_IMPORTED_MODULE_0_perfect_scrollbar__["a" /* default */](el, options);

    var ticks = 0;
    var interval = setInterval(function () {
      el.ps.update();
      ticks++;
      if (ticks >= 20) clearInterval(interval);
    }, 200);
  },
  unbind: function unbind(el, binding) {
    if (binding.value) {
      el.removeEventListener('scroll', binding.callback, { passive: true });
    }

    el.style.position = 'static';
    el.ps.destroy();
  },
  componentUpdated: function componentUpdated(el) {
    el.ps.update();

    var ticks = 0;
    var interval = setInterval(function () {
      el.ps.update();
      ticks++;
      if (ticks >= 20) clearInterval(interval);
    }, 200);
  }
});

/***/ }),

/***/ 956:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

function isVisible(elem) {
  if (!(elem instanceof Element)) {
    throw Error('DomUtil: elem is not an element.');
  }
  var style = getComputedStyle(elem);
  if (style.display === 'none') {
    return false;
  }
  if (style.visibility !== 'visible') {
    return false;
  }
  if (style.opacity < 0.1) {
    return false;
  }
  if (elem.offsetWidth + elem.offsetHeight + elem.getBoundingClientRect().height + elem.getBoundingClientRect().width === 0) {
    return false;
  }
  var elemCenter = {
    x: elem.getBoundingClientRect().left + elem.offsetWidth / 2,
    y: elem.getBoundingClientRect().top + elem.offsetHeight / 2
  };
  if (elemCenter.x < 0) {
    return false;
  }
  if (elemCenter.x > (document.documentElement.clientWidth || window.innerWidth)) {
    return false;
  }
  if (elemCenter.y < 0) {
    return false;
  }
  if (elemCenter.y > (document.documentElement.clientHeight || window.innerHeight)) {
    return false;
  }
  var pointContainer = document.elementFromPoint(elemCenter.x, elemCenter.y);
  do {
    if (pointContainer === elem) {
      return true;
    }
    pointContainer = pointContainer.parentNode;
  } while (pointContainer);
  return false;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: function inserted(el) {
    setTimeout(function () {
      if (isVisible(el)) {
        el.focus();
      }
    }, 500);
  }
});

/***/ }),

/***/ 957:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_highlight_js__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_highlight_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_highlight_js__);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'highlight',
  deep: true,
  bind: function bind(el, binding) {
    var targets = el.querySelectorAll('code');
    targets.forEach(function (target) {
      if (binding.value) {
        target.textContent = binding.value;
      }
      __WEBPACK_IMPORTED_MODULE_0_highlight_js___default.a.highlightBlock(target);
    });
  },
  componentUpdated: function componentUpdated(el, binding) {
    var targets = el.querySelectorAll('code');
    targets.forEach(function (target) {
      if (binding.value) {
        target.textContent = binding.value;
        __WEBPACK_IMPORTED_MODULE_0_highlight_js___default.a.highlightBlock(target);
      }
    });
  }
});

/***/ })

},[424]);


// WEBPACK FOOTER //
// static/js/app.3daab4921ea56e1bf0fb.js